import Image from './Image'

export default class CheckinContent {
  image = undefined
  label = undefined
  title = undefined
  description = undefined


  constructor (source = undefined) {
    this.raw = source
    if(source) {
      this.parseSource(source)
    }
  }

  parseSource (source) {
    for (const prop in source) {
      if(prop in this) {
        this[prop] = source[prop]
      }
    }
    if (source.image) {
      this.image = new Image(source.image[0])
    }
  }

  hasContent() {
    return this.title || this.description
  }

}
